import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { CheckCircle2, MessageCircle, Calendar, Clock, MapPin, ArrowLeft } from 'lucide-react';
const WHATSAPP_GROUP_URL = 'https://chat.whatsapp.com/J2xgq9V4wa54pzFFxcmKuk';
const REDIRECT_DELAY_SECONDS = 10;
export function ThankYouPage() {
  const [secondsRemaining, setSecondsRemaining] = useState(REDIRECT_DELAY_SECONDS);
  useEffect(() => {
    const countdownInterval = window.setInterval(() => {
      setSecondsRemaining(currentSeconds => Math.max(currentSeconds - 1, 0));
    }, 1000);
    const redirectTimeout = window.setTimeout(() => {
      window.location.assign(WHATSAPP_GROUP_URL);
    }, REDIRECT_DELAY_SECONDS * 1000);
    return () => {
      window.clearInterval(countdownInterval);
      window.clearTimeout(redirectTimeout);
    };
  }, []);
  return <div className="min-h-screen w-full bg-brand-dark text-white selection:bg-brand-pink/30 selection:text-white relative overflow-hidden" data-id="element-137">
      {/* Efectos de fondo */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#1f1f1f_1px,transparent_1px),linear-gradient(to_bottom,#1f1f1f_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] opacity-40" data-id="element-138"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand-pink opacity-20 blur-[120px] rounded-full pointer-events-none" data-id="element-139"></div>

      {/* Barra superior con el CTA de WhatsApp */}
      <div className="sticky top-0 z-50 w-full bg-[#25D366] text-black py-3 px-4 shadow-[0_0_15px_rgba(37,211,102,0.4)]" data-id="element-140">
        <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center" data-id="element-141">
          <span className="font-bold text-sm md:text-base" data-id="element-142">
            🎉 Último paso: únete al grupo exclusivo de WhatsApp
          </span>
          <a href={WHATSAPP_GROUP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-black text-white font-bold text-sm px-4 py-1.5 rounded-full hover:bg-gray-900 transition-colors" data-id="element-143">
            <MessageCircle className="w-4 h-4" data-id="element-144" />
            Unirme ahora
          </a>
        </div>
      </div>

      <main className="relative z-10 max-w-3xl mx-auto px-6 py-16 md:py-24 flex flex-col items-center text-center" data-id="element-145">
        {/* Tarjeta principal del grupo de WhatsApp — primero en la página */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="w-full bg-brand-gray border border-white/10 rounded-3xl p-8 md:p-10 shadow-2xl mb-12" data-id="element-146">
          <div className="w-14 h-14 rounded-2xl bg-[#25D366]/15 text-[#25D366] flex items-center justify-center mx-auto mb-5" data-id="element-147">
            <MessageCircle className="w-7 h-7" data-id="element-148" />
          </div>
          <h2 className="text-2xl font-bold mb-3" data-id="element-149">
            Grupo Exclusivo de Inversionistas
          </h2>
          <p className="text-gray-400 mb-8" data-id="element-150">
            Networking anticipado, oportunidades off-market y detalles
            logísticos del evento. Cupo limitado a asistentes confirmados.
          </p>
          <a href={WHATSAPP_GROUP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 w-full sm:w-auto px-8 py-4 text-lg font-bold text-white bg-[#25D366] rounded-full hover:bg-[#1fb855] transition-all duration-300 shadow-[0_0_30px_rgba(37,211,102,0.35)] hover:shadow-[0_0_50px_rgba(37,211,102,0.55)] hover:-translate-y-1" data-id="element-151">
            <MessageCircle className="w-6 h-6" data-id="element-152" />
            Unirme al Grupo de WhatsApp
          </a>
          <p className="mt-5 text-sm text-gray-500" aria-live="polite" data-id="element-153">
            Te llevaremos al grupo automáticamente en {secondsRemaining}{' '}
            {secondsRemaining === 1 ? 'segundo' : 'segundos'}.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} className="w-20 h-20 rounded-full bg-brand-pink/20 text-brand-pink flex items-center justify-center mb-8" data-id="element-154">
          <CheckCircle2 className="w-11 h-11" data-id="element-155" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-4xl md:text-5xl font-extrabold tracking-tight mb-4" data-id="element-156">
          ¡Tu lugar está{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-pink to-purple-500" data-id="element-157">
            asegurado
          </span>
          !
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg text-gray-300 max-w-xl mb-10 leading-relaxed" data-id="element-158">
          Gracias por registrarte a la Cumbre de Inversión Inmobiliaria. Te
          enviaremos tu invitación con código QR por WhatsApp. Para no perderte
          ninguna actualización, únete al grupo exclusivo de asistentes.
        </motion.p>

        {/* Recordatorio de datos del evento */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="grid grid-cols-1 sm:grid-cols-3 gap-4 w-full bg-brand-gray/50 backdrop-blur-md border border-white/10 rounded-2xl p-6 mb-12" data-id="element-159">
          <div className="flex flex-col items-center justify-center gap-2" data-id="element-160">
            <div className="w-10 h-10 rounded-full bg-brand-pink/20 flex items-center justify-center text-brand-pink" data-id="element-161">
              <Calendar className="w-5 h-5" data-id="element-162" />
            </div>
            <p className="text-xs text-gray-400 font-medium uppercase tracking-wider" data-id="element-163">
              Fecha
            </p>
            <p className="font-semibold text-white text-sm" data-id="element-164">
              21 de Julio, 2026
            </p>
          </div>
          <div className="flex flex-col items-center justify-center gap-2 border-t sm:border-t-0 sm:border-l border-white/10 pt-4 sm:pt-0" data-id="element-165">
            <div className="w-10 h-10 rounded-full bg-brand-pink/20 flex items-center justify-center text-brand-pink" data-id="element-166">
              <Clock className="w-5 h-5" data-id="element-167" />
            </div>
            <p className="text-xs text-gray-400 font-medium uppercase tracking-wider" data-id="element-168">
              Horario
            </p>
            <p className="font-semibold text-white text-sm" data-id="element-169">
              9:00 AM - 2:00 PM
            </p>
          </div>
          <div className="flex flex-col items-center justify-center gap-2 border-t sm:border-t-0 sm:border-l border-white/10 pt-4 sm:pt-0" data-id="element-170">
            <div className="w-10 h-10 rounded-full bg-brand-pink/20 flex items-center justify-center text-brand-pink" data-id="element-171">
              <MapPin className="w-5 h-5" data-id="element-172" />
            </div>
            <p className="text-xs text-gray-400 font-medium uppercase tracking-wider" data-id="element-173">
              Sede
            </p>
            <p className="font-semibold text-white text-sm" data-id="element-174">
              San Juan del Río, Qro
            </p>
          </div>
        </motion.div>

        <Link to="/" className="inline-flex items-center gap-2 text-gray-400 hover:text-brand-pink transition-colors text-sm font-medium" data-id="element-175">
          <ArrowLeft className="w-4 h-4" data-id="element-176" />
          Volver al inicio
        </Link>
      </main>
    </div>;
}